export default {
  computed: {
    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    isIE11OrOlder() {
      const ua = window.navigator.userAgent;

      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      // other browser
      return false;
    },

    isEdge() {
      const ua = window.navigator.userAgent;

      const edge = ua.indexOf('Edg');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }
    },

    isNewEdge() {
      const agent = window.navigator.userAgent.toLowerCase();
      return agent.indexOf('edg') > -1 && agent.indexOf('edge') === -1;
    }
  }
};
